import { useTranslation } from 'react-i18next';
import { NoMatchStyled } from '../components/common/styled/NoMatch.styled';

export default function NoMatch() {
    const { t } = useTranslation();
    return (
        <NoMatchStyled>
            <h1>404</h1>
            <h2>{t('404.pageNotFound', 'Page Not Found')}</h2>
        </NoMatchStyled>
    );
}
